// Global Types
import type {
  $FullRegion,
} from 'common.data';

// Helpers
import _ from 'lodash';

// Enums
import * as mainActionTypes from './types';

// Types
import type {
  $ActionEnvelope,
  $ReducerActions,
} from '../..';

export type $State = {
  error: null | string;
  loading: boolean;
  RegionId: null | string;
  regions: Array<$FullRegion>;
};

export const initialState: $State = {
  error: null,
  loading: false,
  RegionId: null,
  regions: [],
};

const actionStart = (state: $State): $State => ({
  ...state,
  error: null,
  loading: true,
});

const actionEnd = (state: $State): $State => ({
  ...state,
  loading: false,
});

const actionError = (state: $State, payload: Error): $State => ({
  ...state,
  error: payload.message,
  loading: false,
});

const setRegion = (state: $State, payload: {
  RegionId: string;
}): $State => ({
  ...state,
  loading: false,
  RegionId: payload.RegionId,
});

const setRegions = (state: $State, payload: Array<$FullRegion>): $State => ({
  ...state,
  loading: false,
  regions: payload,
});

const reducerActions: $ReducerActions<'main'> = {
  [`${mainActionTypes.GET_REGIONS}_FULFILLED`]: setRegions,
  [`${mainActionTypes.GET_REGIONS}_PENDING`]: actionStart,
  [`${mainActionTypes.GET_REGIONS}_REJECTED`]: actionError,
  [`${mainActionTypes.SET_LANGUAGE}_FULFILLED`]: actionEnd,
  [`${mainActionTypes.SET_LANGUAGE}_PENDING`]: actionStart,
  [`${mainActionTypes.SET_LANGUAGE}_REJECTED`]: actionError,
  [`${mainActionTypes.SET_REGION_FROM_HOST}_FULFILLED`]: setRegion,
  [`${mainActionTypes.SET_REGION_FROM_HOST}_PENDING`]: actionStart,
  [`${mainActionTypes.SET_REGION_FROM_HOST}_REJECTED`]: actionError,
  [`${mainActionTypes.SET_REGION_FROM_STORAGE}_FULFILLED`]: setRegion,
  [`${mainActionTypes.SET_REGION_FROM_STORAGE}_PENDING`]: actionStart,
  [`${mainActionTypes.SET_REGION_FROM_STORAGE}_REJECTED`]: actionError,
  [`${mainActionTypes.SET_REGION}_FULFILLED`]: setRegion,
  [`${mainActionTypes.SET_REGION}_PENDING`]: actionStart,
  [`${mainActionTypes.SET_REGION}_REJECTED`]: actionError,
  [`${mainActionTypes.SETUP_LANGUAGE}_FULFILLED`]: actionEnd,
  [`${mainActionTypes.SETUP_LANGUAGE}_PENDING`]: actionStart,
  [`${mainActionTypes.SETUP_LANGUAGE}_REJECTED`]: actionError,
  [`${mainActionTypes.SETUP_REGION}_FULFILLED`]: actionEnd,
  [`${mainActionTypes.SETUP_REGION}_PENDING`]: actionStart,
  [`${mainActionTypes.SETUP_REGION}_REJECTED`]: actionError,
  [`${mainActionTypes.SETUP_USER}_FULFILLED`]: actionEnd,
  [`${mainActionTypes.SETUP_USER}_PENDING`]: actionStart,
  [`${mainActionTypes.SETUP_USER}_REJECTED`]: actionError,
};

export type $Reducer = (arg0: $State, arg1: $ActionEnvelope<$ReducerActions<'main'>>) => $State;

const reducer: $Reducer = (prevState, action) => {
  const state = prevState || initialState;

  const reducerAction = _.get(
    reducerActions,
    action.type,
    () => state,
  );

  return reducerAction(
    state,
    action.payload,
  );
};

export default reducer;
